import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionWithIssues: {
		id: 'project-directories.versions.release-version-modal.content.description-with-issues',
		defaultMessage: 'This release contains {issueCountLink}.',
		description: '',
	},
	descriptionWithIssuesCount: {
		id: 'project-directories.versions.release-version-modal.content.description-with-issues-count',
		defaultMessage:
			'{issues, plural, one {{issues} unresolved issue} other {{issues} unresolved issues}}',
		description: '',
	},
	descriptionWithoutIssues: {
		id: 'project-directories.versions.release-version-modal.content.description-without-issues',
		defaultMessage: '{doneIssues} {doneIssues, plural, one {issue} other {issues}}',
		description: '',
	},
	descriptionWithoutIssuesRestMessage: {
		id: 'project-directories.versions.release-version-modal.content.description-without-issues-rest-message',
		defaultMessage: '{issueCountLink} will be released.',
		description: '',
	},
	descriptionWithIssuesCountIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.description-with-issues-count-issue-term-refresh',
		defaultMessage:
			'{issues, plural, one {{issues} unresolved work item} other {{issues} unresolved work items}}',
		description: '',
	},
	descriptionWithoutIssuesIssueTermRefresh: {
		id: 'project-directories.versions.release-version-modal.content.description-without-issues-issue-term-refresh',
		defaultMessage: '{doneIssues} {doneIssues, plural, one {work item} other {work items}}',
		description: '',
	},
});
